/** card — EN source (75 keys). */
export const card = {
  card_toasts_region_label: "Notifications",
  card_loading: "Loading…",
  card_load_failed: "Couldn't load your card. Pull to refresh.",
  card_write_unavailable_try_again: "Something went wrong — try again.",
  card_action_share: "Share card",
  card_action_copy_link: "Copy link",
  card_action_more: "More",
  card_action_contact: "Contact",
  card_action_coming_soon: "Coming soon",
  card_action_link_copied: "Link copied.",
  card_item_kind_phone_label: "Phone",
  card_item_kind_email_label: "Email",
  card_item_kind_instagram_label: "Instagram",
  card_item_kind_tiktok_label: "TikTok",
  card_item_kind_linkedin_label: "LinkedIn",
  card_item_kind_x_label: "X",
  card_item_kind_youtube_label: "YouTube",
  card_item_kind_url_label: "Link",
  card_editor_entry_label: "Edit card",
  card_no_items_placeholder: "Add a contact, social, or link to share.",
  card_editor_phase_4_placeholder: "Editor coming in Phase 4",
  card_retry: "Try again",
  card_editor_save_button: "Save",
  card_editor_cancel_button: "Cancel",
  card_editor_remove_button: "Remove",
  card_editor_section_identity: "IDENTITY",
  card_editor_section_style: "STYLE",
  card_editor_section_contact: "CONTACT",
  card_editor_section_socials: "SOCIALS",
  card_editor_section_links: "LINKS",
  card_editor_identity_display_name_label: "Display name",
  card_editor_identity_bio_label: "Bio",
  card_editor_identity_avatar_label: "Avatar",
  card_editor_identity_avatar_change: "Change",
  card_editor_style_theme_label: "Theme",
  card_editor_add_contact_row: "+ Add contact",
  card_editor_add_social_row: "+ Add social",
  card_editor_add_link_row: "+ Add link",
  card_editor_add_picker_title_contact: "Add contact",
  card_editor_add_picker_title_social: "Add social",
  card_items_cap_reached_hint:
    "You've reached the 30-item limit. Remove one to add another.",
  card_items_cap_reached: "Item limit reached — couldn't save.",
  card_save_failed_generic: "Couldn't save your card. Try again.",
  card_link_not_allowed: "This link isn't allowed on Linqx.",
  card_theme_picker_title: "Theme",
  card_theme_picker_badge_free: "Free",
  card_theme_picker_badge_premium: "Premium",
  card_theme_picker_prev: "Previous theme",
  card_theme_picker_next: "Next theme",
  card_theme_premium_locked: "Premium themes aren't available yet.",
  card_item_sheet_phone_label_header: "PHONE NUMBER",
  card_item_sheet_email_label_header: "EMAIL ADDRESS",
  card_item_sheet_email_format_hint: "Format: name@domain.com",
  card_item_sheet_label_label_header: "LABEL",
  card_item_sheet_url_label_header: "URL",
  card_item_sheet_url_error: "URL must start with http:// or https://",
  card_item_sheet_label_counter: "{count} / 50",
  card_item_sheet_title_custom_link: "Custom link",
  card_lite_explainer_text:
    "Contact details unlock after you meet — request to connect to share contact info.",
  card_lite_request_to_connect: "Request to connect",
  card_lite_request_sent: "Request sent",
  card_lite_request_sent_success:
    "Request sent — you'll see their contact info once you both confirm.",
  card_lite_cannot_connect_to_self:
    "You can't request to connect with yourself.",
  card_unavailable_title: "Card unavailable",
  card_unavailable_message:
    "This card is no longer available. The owner may have deleted their account.",
  card_unavailable_back_button: "Back",
  card_share_action_label: "Share card",
  card_launcher_tab_title: "My Card",
  card_launcher_tab_subtitle:
    "Your digital contact card lives in the MyLinqx Card mini-app — open it to view, edit, and share.",
  card_launcher_tab_open_button: "Open MyLinqx Card",

  // MyLinqx Card — Connections list + card-viewer message hand-off
  connections_title: "Connections",
  connections_empty_heading: "No connections yet",
  connections_empty_body:
    "People appear here once you both confirm your meetup.",
  connections_message_button: "Message {name}",
  connections_message_button_short: "Message",
  connections_load_failed: "Couldn't load your connections. Try again.",
};
